//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  at: "অস্ট্রিয়া",
  au: "অস্ট্রেলিয়া",
  ao: "অ্যাঙ্গোলা",
  aq: "অ্যান্টার্কটিকা",
  ag: "অ্যান্টিগুয়া ও বারবুডা",
  im: "আইল অফ ম্যান",
  is: "আইসল্যান্ড",
  az: "আজারবাইজান",
  ad: "আন্ডোরা",
  af: "আফগানিস্তান",
  as: "আমেরিকান সামোয়া",
  ie: "আয়ারল্যান্ড",
  aw: "আরুবা",
  ar: "আর্জেন্টিনা",
  am: "আর্মেনিয়া",
  dz: "আলজেরিয়া",
  al: "আলবেনিয়া",
  ax: "আলান্ড দ্বীপপুঞ্জ",
  ua: "ইউক্রেন",
  ec: "ইকুয়েডর",
  il: "ইজরায়েল",
  it: "ইতালি",
  et: "ইথিওপিয়া",
  id: "ইন্দোনেশিয়া",
  ye: "ইয়েমেন",
  iq: "ইরাক",
  ir: "ইরান",
  er: "ইরিত্রিয়া",
  sz: "ইসওয়াতিনি",
  ug: "উগান্ডা",
  uz: "উজবেকিস্তান",
  kp: "উত্তর কোরিয়া",
  mk: "উত্তর ম্যাসেডোনিয়া",
  mp: "উত্তরাঞ্চলীয় মারিয়ানা দ্বীপপুঞ্জ",
  uy: "উরুগুয়ে",
  sv: "এল সালভেদর",
  ee: "এস্তোনিয়া",
  ai: "এ্যাঙ্গুইলা",
  om: "ওমান",
  wf: "ওয়ালিস ও ফুটুনা",
  cg: "কঙ্গো - ব্রাজাভিল",
  cd: "কঙ্গো-কিনশাসা",
  km: "কমোরোস",
  kh: "কম্বোডিয়া",
  co: "কলম্বিয়া",
  kz: "কাজাখস্তান",
  qa: "কাতার",
  ca: "কানাডা",
  cu: "কিউবা",
  kg: "কিরগিজিস্তান",
  ki: "কিরিবাতি",
  ck: "কুক দ্বীপপুঞ্জ",
  kw: "কুয়েত",
  cw: "কুরাসাও",
  ke: "কেনিয়া",
  cv: "কেপভার্দে",
  ky: "কেম্যান দ্বীপপুঞ্জ",
  cc: "কোকোস (কিলিং) দ্বীপপুঞ্জ",
  ci: "কোত দিভোয়ার",
  cr: "কোস্টারিকা",
  cm: "ক্যামেরুন",
  bq: "ক্যারিবিয়ান নেদারল্যান্ডস",
  cx: "ক্রিসমাস দ্বীপ",
  hr: "ক্রোয়েশিয়া",
  gm: "গাম্বিয়া",
  gn: "গিনি",
  gw: "গিনি-বিসাউ",
  gy: "গিয়ানা",
  gt: "গুয়াতেমালা",
  gp: "গুয়াদেলৌপ",
  gu: "গুয়াম",
  gg: "গুয়ার্নসি",
  ga: "গ্যাবন",
  gl: "গ্রীনল্যান্ড",
  gr: "গ্রীস",
  gd: "গ্রেনাডা",
  gh: "ঘানা",
  td: "চাদ",
  cl: "চিলি",
  cn: "চীন",
  cz: "চেচিয়া",
  ge: "জর্জিয়া",
  jo: "জর্ডন",
  jp: "জাপান",
  jm: "জামাইকা",
  zm: "জাম্বিয়া",
  de: "জার্মানি",
  je: "জার্সি",
  dj: "জিবুতি",
  gi: "জিব্রাল্টার",
  zw: "জিম্বাবোয়ে",
  tv: "টুভালু",
  tk: "টোকেলাউ",
  tg: "টোগো",
  to: "টোঙ্গা",
  dk: "ডেনমার্ক",
  dm: "ডোমিনিকা",
  do: "ডোমেনিকান প্রজাতন্ত্র",
  tw: "তাইওয়ান",
  tj: "তাজিকিস্তান",
  tz: "তাঞ্জানিয়া",
  tn: "তিউনিসিয়া",
  tl: "তিমুর-লেস্তে",
  tr: "তুরস্ক",
  tm: "তুর্কমেনিস্তান",
  tc: "তুর্কস ও কাইকোস দ্বীপপুঞ্জ",
  tt: "ত্রিনিনাদ ও টোব্যাগো",
  th: "থাইল্যান্ড",
  za: "দক্ষিণ আফ্রিকা",
  kr: "দক্ষিণ কোরিয়া",
  gs: "দক্ষিণ জর্জিয়া ও দক্ষিণ স্যান্ডউইচ দ্বীপপুঞ্জ",
  ss: "দক্ষিণ সুদান",
  no: "নরওয়ে",
  nf: "নরফোক দ্বীপ",
  ne: "নাইজার",
  ng: "নাইজেরিয়া",
  nr: "নাউরু",
  na: "নামিবিয়া",
  nc: "নিউ ক্যালেডোনিয়া",
  nz: "নিউজিল্যান্ড",
  nu: "নিউয়ে",
  ni: "নিকারাগুয়া",
  gq: "নিরক্ষীয় গিনি",
  nl: "নেদারল্যান্ডস",
  np: "নেপাল",
  pt: "পর্তুগাল",
  eh: "পশ্চিম সাহারা",
  pk: "পাকিস্তান",
  pa: "পানামা",
  pg: "পাপুয়া নিউ গিনি",
  pw: "পালাউ",
  pn: "পিটকেয়ার্ন দ্বীপপুঞ্জ",
  pr: "পুয়ের্তো রিকো",
  pe: "পেরু",
  pl: "পোল্যান্ড",
  py: "প্যারাগুয়ে",
  ps: "প্যালেস্টাইনের অঞ্চলসমূহ",
  fk: "ফকল্যান্ড দ্বীপপুঞ্জ",
  gf: "ফরাসী গায়ানা",
  tf: "ফরাসী দক্ষিণাঞ্চল",
  pf: "ফরাসী পলিনেশিয়া",
  fj: "ফিজি",
  fi: "ফিনল্যান্ড",
  ph: "ফিলিপাইন",
  fo: "ফ্যারও দ্বীপপুঞ্জ",
  fr: "ফ্রান্স",
  bw: "বতসোয়ানা",
  bo: "বলিভিয়া",
  ba: "বসনিয়া ও হার্জেগোভিনা",
  bd: "বাংলাদেশ",
  bb: "বারবাদোস",
  bm: "বারমুডা",
  bh: "বাহরাইন",
  bs: "বাহামা দ্বীপপুঞ্জ",
  bf: "বুরকিনা ফাসো",
  bi: "বুরুন্ডি",
  bg: "বুলগেরিয়া",
  bj: "বেনিন",
  be: "বেলজিয়াম",
  by: "বেলারুশ",
  bz: "বেলিজ",
  bv: "বোভেট দ্বীপ",
  br: "ব্রাজিল",
  io: "ব্রিটিশ ভারত মহাসাগরীয় অঞ্চল",
  vg: "ব্রিটিশ ভার্জিন দ্বীপপুঞ্জ",
  bn: "ব্রুনেই",
  vu: "ভানুয়াটু",
  in: "ভারত",
  vn: "ভিয়েতনাম",
  bt: "ভুটান",
  ve: "ভেনেজুয়েলা",
  va: "ভ্যাটিকান সিটি",
  mn: "মঙ্গোলিয়া",
  cf: "মধ্য আফ্রিকার প্রজাতন্ত্র",
  ms: "মন্টসেরাট",
  me: "মন্টিনিগ্রো",
  mr: "মরিতানিয়া",
  mu: "মরিশাস",
  md: "মলডোভা",
  fm: "মাইক্রোনেশিয়া",
  mg: "মাদাগাস্কার",
  mm: "মায়ানমার (বার্মা)",
  yt: "মায়োত্তে",
  us: "মার্কিন যুক্তরাষ্ট্র",
  vi: "মার্কিন যুক্তরাষ্ট্রের ভার্জিন দ্বীপপুঞ্জ",
  mq: "মার্টিনিক",
  mh: "মার্শাল দ্বীপপুঞ্জ",
  mv: "মালদ্বীপ",
  my: "মালয়েশিয়া",
  mw: "মালাউই",
  ml: "মালি",
  mt: "মাল্টা",
  eg: "মিশর",
  mx: "মেক্সিকো",
  mz: "মোজাম্বিক",
  mc: "মোনাকো",
  ma: "মোরক্কো",
  mo: "ম্যাকাও এসএআর চীনা",
  gb: "যুক্তরাজ্য",
  um: "যুক্তরাষ্ট্রের পার্শ্ববর্তী দ্বীপপুঞ্জ",
  ru: "রাশিয়া",
  re: "রিইউনিয়ন",
  rw: "রুয়ান্ডা",
  ro: "রোমানিয়া",
  lr: "লাইবেরিয়া",
  la: "লাওস",
  lu: "লাক্সেমবার্গ",
  lv: "লাত্ভিয়া",
  li: "লিচেনস্টেইন",
  lt: "লিথুয়ানিয়া",
  ly: "লিবিয়া",
  lb: "লেবানন",
  ls: "লেসোথো",
  lk: "শ্রীলঙ্কা",
  ae: "সংযুক্ত আরব আমিরাত",
  sb: "সলোমন দ্বীপপুঞ্জ",
  cy: "সাইপ্রাস",
  st: "সাওটোমা ও প্রিন্সিপি",
  sm: "সান মারিনো",
  ws: "সামোয়া",
  rs: "সার্বিয়া",
  sg: "সিঙ্গাপুর",
  sx: "সিন্ট মার্টেন",
  sl: "সিয়েরা লিওন",
  sy: "সিরিয়া",
  sc: "সিসিলি",
  ch: "সুইজারল্যান্ড",
  se: "সুইডেন",
  sd: "সুদান",
  sr: "সুরিনাম",
  sn: "সেনেগাল",
  kn: "সেন্ট কিটস ও নেভিস",
  pm: "সেন্ট পিয়ের ও মিকুয়েলন",
  bl: "সেন্ট বারথেলিমি",
  vc: "সেন্ট ভিনসেন্ট ও গ্রেনাডিনস",
  mf: "সেন্ট মার্টিন",
  lc: "সেন্ট লুসিয়া",
  sh: "সেন্ট হেলেনা",
  so: "সোমালিয়া",
  sa: "সৌদি আরব",
  es: "স্পেন",
  sj: "স্বালবার্ড ও জান মেয়েন",
  sk: "স্লোভাকিয়া",
  si: "স্লোভানিয়া",
  hk: "হংকং এসএআর চীনা",
  hn: "হন্ডুরাস",
  ht: "হাইতি",
  hu: "হাঙ্গেরি",
  hm: "হার্ড এবং ম্যাকডোনাল্ড দ্বীপপুঞ্জ",
};
